import { updateIncidentStatusUseCase } from '@src/main/modules/other_incidents/application/use-cases/update/update-incident-status.usecase';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateIncidentStatus = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  return useMutation({
    mutationFn: async ({ id, status }: { id: string; status: string }) =>
      await updateIncidentStatusUseCase({ id, status }, tokenProvider),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['incidents'] });
    },
  });
};
